import { useParams } from "react-router-dom";
import { canUsePermission } from "../../../lib/auth";
import { useCurrentAuthUser } from "../../auth";
import { RefundAdminView, RefundPublicView } from "..";

/** 团退票员工管理页。 */
export function TicketRefundAdminPage() {
  const { teamId = "" } = useParams();
  const user = useCurrentAuthUser();
  return <RefundAdminView key={teamId} teamId={teamId} canApprove={user.isSuccess && canUsePermission(user.data, "order_handover.ticket_refund:approve")} />;
}

/** 无需员工登录的扫码申请页。 */
export function TicketRefundPublicPage() {
  const { token = "" } = useParams();
  return <RefundPublicView key={token} token={token} />;
}
